

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { DataService } from '../../../services/forms/referenc-center/data.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/map-reference-PI-list.component.html',
})
export class MapReferencePIListComponent implements OnInit {
  @Input()
  PI_NO: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  mapReferancePIList: any[] = [];
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "MapReferencePIListGrid"
  searchFields: any[] = ['PI_DATE', 'PI_ID', 'CUSTOMER_NAME', 'TOTAL_VALUE'];
  public searchString;
  constructor(private apiService: DataService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.pi_ID, field: 'PI_ID', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.pi_Date, field: 'PI_DATE', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.customerName, field: 'CUSTOMER_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.totalValue, field: 'TOTAL_VALUE', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    this.apiService.getReferenceInvoicePI()
      .subscribe(arg => { console.log(arg); this.mapReferancePIList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }
}
